import React from 'react'
import { useTranslation } from 'react-i18next'

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    // Пишем явно: LanguageDetector кэширует при смене, но часть сборок
    // i18next делала это асинхронно — без записи язык снова брался из navigator.
    localStorage.setItem('i18nextLng', lng);
    i18n.changeLanguage(lng);
  };

  return (
    <div className="inline-flex items-center rounded-xl bg-white/[0.04] p-1">
      <button
        type="button"
        onClick={() => changeLanguage('kk')}
        className={`rounded-lg px-2.5 py-1 text-xs font-semibold transition ${
          i18n.language === 'kk' || i18n.language?.startsWith('kk')
            ? 'bg-white/[0.1] text-white'
            : 'text-muted-400 hover:text-white'
        }`}
      >
        KZ
      </button>
      <button
        type="button"
        onClick={() => changeLanguage('ru')}
        className={`rounded-lg px-2.5 py-1 text-xs font-semibold transition ${
          i18n.language === 'ru' || i18n.language?.startsWith('ru')
            ? 'bg-white/[0.1] text-white'
            : 'text-muted-400 hover:text-white'
        }`}
      >
        RU
      </button>
    </div>
  );
};

export default LanguageSwitcher;

